import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PushNotificationService } from './services/pushNotification.service';
import { BtnActionComponent } from './views/components/buttons/btn-action/btn-action.component';
import { BtnTextComponent } from './views/components/buttons/btn-text/btn-text.component';
// import { OneSignal } from 'onesignal-ngx';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, BtnTextComponent, BtnActionComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'AtChurch Webapp';
  private pushService = inject(PushNotificationService);
  showNotificationPrompt = false;

  // constructor(private oneSignal: OneSignal) {
  constructor() {
    // this.oneSignal.init({
    //   appId: environment.ONE_SIGNAL_APPID,
    // });
  }

  ngOnInit() {
    // Check if we should even show the prompt
    if (Notification.permission === 'default') {
      // Wait a bit so the app loads, then show the UI (not the system popup)
      setTimeout(() => (this.showNotificationPrompt = true), 2000);
    } else if (Notification.permission === 'granted') {
      // If already granted, just refresh the service worker quietly
      this.pushService.initPushNotifications();
      this.pushService.listenForForegroundMessages();
    }
  }

  async enableNotifications() {
    // This is the "User Gesture" that Safari requires!
    this.showNotificationPrompt = false;
    await this.pushService.initPushNotifications();
    this.pushService.listenForForegroundMessages();
  }

  dismissPrompt() {
    this.showNotificationPrompt = false;
  }
}
